<template>
  <div class="item" @click.capture="showModal">
    <div class="popular-img">
      <div
        v-lazy:background-image="product.PhotoUrl"
        class="popular-div-img"
        :style="imageRatioStyle"
      ></div>
    </div>
    <div class="popular-item-details with-image">
      <h2 class="item-title" style="font-size: 1.5em !important;font-weight: 600">{{ category.Name }}</h2>
    </div>
    <div class="popular-item-price with-image">
      <h2 class="item-price">{{ category.Price | formatMoney(currencySign) }}</h2>
    </div>
    <div v-if="product.Status == 3" class="sold-out">
      <h4></h4>
    </div>
    <AddToCart
      v-if="isModalVisible"
      :price="category.Price"
      :product-id="category.ProductID"
      :category="category"
      :parent-category="parentCategory"
      :product="product"
      :modifiers="modifiers"
      :image-styles="dialogImageRatioStyle"
    />
  </div>
</template>

<script>
import AddToCart from "./AddToCartMobile";
import shared from "../../../sharedscripts/shop/products/Product.js";
export default {
  name: "PoplarProduct",
  components: { AddToCart },
  filters: {
    ...shared.filters
  },
  props: {
    product: {
      type: Object,
      default: () => {}
    },
    category: {
      type: Object,
      default: () => {}
    },
    parentCategory: {
      type: Object,
      default: () => {}
    },
    modifiers: {
      type: Object,
      default: () => {}
    },
    sectionId: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      isModalVisible: false,
      width: 0,
      height: 0
    };
  },
  computed: {
    ...shared.computed
  },
  mounted() {
    this.getImageWidthHeight();
  },
  methods: {
    ...shared.methods
  }
};
</script>
<style scoped>
.item {
  padding: 0px !important;
  border-bottom: none !important;
  height: 100%;
}
.popular-img {
  width: 100%;
  float: none;
  margin-left: 0px;
}
.popular-div-img {
  width: 100%;
  height: 120px;
  border-radius: 10px;
  background-size: cover;
  background-position: center;
}
.item-title {
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  line-height: 14px;
  max-height: 42px;
}
.item-price {
  text-align: left;
}
.popular-item-price {
  text-align: left;
  bottom: -75px;
  position: absolute;
}
.popular-item-details {
  margin-top: 10px;
  font-size: 0.8em;
}
</style>